import {
    Box,
    Button,
    Center,
    Stack,
    Text,
    ThemeIcon,
    UnstyledButton,
} from '@mantine/core'
import {
    X,
} from 'lucide-react'

import ModalHeader from '@/modules/Cart/shared/ModalHeader/ModalHeader'
import { WithViewModelProps } from '@/shared/types/components'
import eventEmitter from '@/utils/event-emitter'

import Footer from '@/modules/Cart/Footer'
import { useViewModel } from './OrderShipping.vm'
import StoreShippingOption from './StoreShippingOption/StoreShippingOption'

export const OrderShippingTitle = () => {
    const metadata = {
        title: 'Options de livraison',
        description:
            'Sélectionnez une option de livraison pour chaque magasin.',
    }
    return <ModalHeader {...metadata} />
}

export const OrderShipping = () => {
    const viewModel = useViewModel()
    return <OrderShippingView viewModel={viewModel} />
}

const OrderShippingView = ({
    viewModel,
}: WithViewModelProps<typeof useViewModel>) => {
    const hasShippingOptions = Object.values(viewModel.dataSource).length > 0

    if (!hasShippingOptions) {
        return (
            <Box>
                <Center className="p-4 h-full" mt="xl">
                    <Stack align="center" className="text-center gap-2">
                        <ThemeIcon variant="light" color="red">
                            <X className="w-4 h-4" />
                        </ThemeIcon>
                        <Text size="xs" c="gray.6">
                            Une erreur survenue lors du chargement des options
                            de livraison.s
                        </Text>
                        <Text size="xs" c="gray.6">
                            Pas de panique, vous pouvez toujours réessayer en
                            cliquant{' '}
                            <UnstyledButton
                                className="text-blue-400 text-sm underline underline-offset-2"
                                onClick={() => window.location.reload()}
                            >
                                ici
                            </UnstyledButton>
                        </Text>
                    </Stack>
                </Center>
                <Footer>
                    <Button
                        color="gray"
                        variant="outline"
                        size="sm"
                        onClick={() => eventEmitter.emit('TOGGLE_CART_DRAWER')}
                    >
                        Fermer le panier
                    </Button>
                </Footer>
            </Box>
        )
    }

    return (
        <Box>
            <Stack className="p-4">
                {Object.values(viewModel.dataSource).map((store) => {
                    const selectedShippingOptionId = viewModel.fields.find(
                        (field) => {
                            return field.store_id === store.id
                        },
                    )?.shipping_option_selected

                    return (
                        <StoreShippingOption
                            key={store.id}
                            dataSource={store}
                            selectedShippingOptionId={selectedShippingOptionId}
                            onSelectShippingOption={(shippingOption) =>
                                viewModel.onSelectShippingOption({
                                    store_id: store.id,
                                    shipping_option_id: shippingOption.id,
                                })
                            }
                        />
                    )
                })}
            </Stack>

            <Footer>
                <Button
                    className="ml-auto max-w-max"
                    onClick={viewModel.onSubmit}
                    disabled={!viewModel.hasSelectedForAllStores}
                >
                    Suivant
                </Button>
            </Footer>
        </Box>
    )
}
